import { MDCSnackbar } from '@material/snackbar'

export default {
  setup() {
    this.snackbar = new MDCSnackbar(this.el)
  },
  destroy() {
    this.snackbar?.destroy()
    this.snackbar = null
  },
  mounted() {
    this.setup()

    this.handleEvent('open-snackbar', ({ timeout }) => {
      this.snackbar.timeoutMs = timeout
      this.snackbar.open()
    })
  },
  destroyed() {
    this.destroy()
  }
}
